import "../../Components/CompactOrderPreviewTable.css";

interface IWarningRow {
  userName: string;
  message: string;
}

interface IProps {
  rows: IWarningRow[] | null | undefined;
}

const PreviewWarningsTable = ({ rows }: IProps) => {
  if (!rows?.length) return null;

  return (
    <table className="preview-warning-table w-full max-w-[720px] border-collapse rounded border border-orange-300 bg-orange-50 text-xs text-orange-800">
      <colgroup><col style={{ width: 36 }} /><col style={{ width: "24%" }} /><col /></colgroup>
      <thead>
        <tr>
          <th className="border border-orange-300 px-3 py-2 text-right">#</th>
          <th className="border border-orange-300 px-3 py-2 text-right">کاربر</th>
          <th className="border border-orange-300 px-3 py-2 text-right">هشدار</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          <tr key={`${row.userName}-${index}`}>
            <td className="border border-orange-200 px-3 py-2">{index + 1}</td>
            <td className="border border-orange-200 px-3 py-2">{row.userName}</td>
            <td className="border border-orange-200 px-3 py-2">{row.message}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PreviewWarningsTable;
